import { useState, useEffect } from 'react';
import request from '../../../../../../lib/request';
import config from '../../../../../../config';
import { messaging, getToken } from '../../../../../../lib/firebase';

const AppPushNotification = ({ icon = null, notificationSetting }) => {
  const [isNotificationEnabled, setIsNotificationEnabled] = useState(false);

  useEffect(() => {
    setIsNotificationEnabled(notificationSetting.appPush);
  }, [notificationSetting.appPush]);

  const toggleNotification = async () => {
    try {
      if (!isNotificationEnabled) {
        const status = await Notification.requestPermission();
        if (status === 'granted') {
          const token = await getToken(messaging, {
            vapidKey: config.fcm.vapidKey,
          });

          const userAgent =
            navigator.userAgent || navigator.vendor || window.opera;
          let device = '';

          if (/android/i.test(userAgent)) {
            device = 'AOS';
          }

          // iOS detection for Safari, Chrome, and other browsers on iPhone/iPad
          if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            device = 'IOS';
          }

          const localToken = window.localStorage.getItem('fcmToken');
          if (localToken !== token) {
            const { result } = await request.post('/user/device-token', {
              oldToken: localToken || null,
              newToken: token,
              device,
            });
            if (result?.token) {
              window.localStorage.setItem('fcmToken', result.token);
            }
          }
        } else {
          console.warn('Notification permission denied.');

          try {
            window.localStorage.removeItem('fcmToken');
            await request.delete(`/user/device-token`);
          } catch (err) {
            console.log(err?.message);
          }

          return window.confirm(
            'You need to enable notification permission on your browser to receive app push notifications.\n\nAndroid: [Settings] > [Apps] > [TheChamps] > [Notifications] > [Turn ON]\n\niOS: [Settings] > [Notifications] > [TheChamps] > [Allow Notifications]'
          );
        }
      } else {
        try {
          window.localStorage.removeItem('fcmToken');
          await request.delete(`/user/device-token`);
        } catch (err) {
          console.log(err?.message);
        }
      }

      const { result } = await request.put('/user/notification', {
        appPush: !isNotificationEnabled,
      });

      if (result) {
        setIsNotificationEnabled(result.appPush);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className='flex items-center py-4 border-b gap-2'>
      <div className='flex-1'>
        <div className='flex items-center gap-1'>
          {icon}
          <h2 className='text-sm font-semibold text-gray-900'>
            App Push Notifications
          </h2>
        </div>
        <p className='text-sm text-gray-500'>
          Receive app push notifications from The Champs.
        </p>
      </div>
      <button
        type='button'
        role='switch'
        aria-checked={isNotificationEnabled}
        onClick={toggleNotification}
        className={`${
          isNotificationEnabled ? 'bg-black' : 'bg-gray-200'
        } relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out  focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2`}
      >
        <span
          aria-hidden='true'
          className={`${
            isNotificationEnabled ? 'translate-x-5' : 'translate-x-0'
          } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}
        />
      </button>
    </div>
  );
};

export default AppPushNotification;
